export const ANIMATION_DURATION = 4200
